import { action, makeObservable, observable } from "mobx";
import { WithBooleanFlag } from "./core";

export class DefectPopup {
  selectedDefect = null;
  openPopupDefect: WithBooleanFlag = new WithBooleanFlag(false);

  constructor() {
    makeObservable(
      this,
      {
        selectedDefect: observable,
        setDefect: action,

        openPopupDefect: observable,
        togglePopupDefect: action,
      }
    );
  }

  togglePopupDefect = () => {
    this.openPopupDefect.toggle();
    if(!this.openPopupDefect.value) {
      this.setDefect(null);
    }
  }

  setDefect = (defect) => {
    this.selectedDefect = defect;
  }
}

const defectPopupStore = new DefectPopup();
export default defectPopupStore;
